// extracted by mini-css-extract-plugin
module.exports = {"note":"note___aBZcg","isCentered":"isCentered___1z_uo","isInputLike":"isInputLike___1VXdJ"};